// extracted by mini-css-extract-plugin
export default {"progressDateContainer":"progressDateContainer-Zwxz2n4B"};